module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/BrandFleetwood-4883ca5126c80b4b58edb42590ace03e.svg";